<p>shopping-cart-adhoc works!</p>
